var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 331,
    height: 323.268,
    viewBox: "0 0 331 323.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_007_shop_store_market_marketing_building_shopping_2090367",
    transform: "translate(0 -2.56)",
    opacity: 0.461
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M4.681,118.151A77.578,77.578,0,0,1,65.476,53.5a50.917,50.917,0,0,0,28.29-17.041A95.68,95.68,0,0,1,260.119,77.009a50.607,50.607,0,0,0,26.92,34.057,72.406,72.406,0,1,1-97.386,96.559,24.334,24.334,0,0,0-22.006-13.68H165.5a32.04,32.04,0,0,0-31.031,25.187A51.807,51.807,0,0,1,32.4,209.461a55.287,55.287,0,0,0-11.714-31.936A77.345,77.345,0,0,1,4.681,118.151Z",
    fill: "#97c1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M113.781,31.031a2.586,2.586,0,0,1-1.836-.776,3.1,3.1,0,0,1-.569-.827,2.828,2.828,0,0,1,0-1.991,3.1,3.1,0,0,1,.569-.827,2.586,2.586,0,0,1,2.327-.7h.491l.44.233a1.629,1.629,0,0,1,.388.336,2.682,2.682,0,0,1,0,3.775,1.578,1.578,0,0,1-.388.336,2.275,2.275,0,0,1-.44.233,2.715,2.715,0,0,1-.491.155Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M144.813,41.375H129.3a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M162.914,31.031H124.125a2.586,2.586,0,0,1,0-5.172h38.789a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M137.055,51.719h-18.1a2.586,2.586,0,0,1,0-5.172h18.1a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M118.953,41.375H108.609a2.586,2.586,0,0,1,0-5.172h10.344a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M113.781,31.031a2.586,2.586,0,0,1-1.836-.776,3.1,3.1,0,0,1-.569-.827,2.828,2.828,0,0,1,0-1.991,3.1,3.1,0,0,1,.569-.827,2.586,2.586,0,0,1,2.327-.7h.491l.44.233a1.629,1.629,0,0,1,.388.336,2.682,2.682,0,0,1,0,3.775,1.578,1.578,0,0,1-.388.336,2.275,2.275,0,0,1-.44.233,2.715,2.715,0,0,1-.491.155Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M144.813,41.375H129.3a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M162.914,31.031H124.125a2.586,2.586,0,0,1,0-5.172h38.789a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M137.055,51.719h-18.1a2.586,2.586,0,0,1,0-5.172h18.1a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M118.953,41.375H108.609a2.586,2.586,0,0,1,0-5.172h10.344a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 10.344,
    height: 10.344,
    transform: "translate(41.375 204.289)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M51.719,217.219H41.375a2.586,2.586,0,0,1-2.586-2.586V204.289a2.586,2.586,0,0,1,2.586-2.586H51.719a2.586,2.586,0,0,1,2.586,2.586v10.344A2.586,2.586,0,0,1,51.719,217.219Zm-7.758-5.172h5.172v-5.172H43.961Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 10.344,
    height: 10.344,
    transform: "translate(41.375 178.43)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M51.719,191.359H41.375a2.586,2.586,0,0,1-2.586-2.586V178.43a2.586,2.586,0,0,1,2.586-2.586H51.719A2.586,2.586,0,0,1,54.3,178.43v10.344A2.586,2.586,0,0,1,51.719,191.359Zm-7.758-5.172h5.172v-5.172H43.961Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 10.344,
    height: 10.344,
    transform: "translate(41.375 152.57)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M51.719,165.5H41.375a2.586,2.586,0,0,1-2.586-2.586V152.57a2.586,2.586,0,0,1,2.586-2.586H51.719A2.586,2.586,0,0,1,54.3,152.57v10.344A2.586,2.586,0,0,1,51.719,165.5Zm-7.758-5.172h5.172v-5.172H43.961Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 10.344,
    height: 10.344,
    transform: "translate(41.375 126.711)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M51.719,139.641H41.375a2.586,2.586,0,0,1-2.586-2.586V126.711a2.586,2.586,0,0,1,2.586-2.586H51.719a2.586,2.586,0,0,1,2.586,2.586v10.344A2.586,2.586,0,0,1,51.719,139.641Zm-7.758-5.172h5.172V129.3H43.961Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 10.344,
    height: 10.344,
    transform: "translate(41.375 100.852)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M51.719,113.781H41.375a2.586,2.586,0,0,1-2.586-2.586V100.852a2.586,2.586,0,0,1,2.586-2.586H51.719a2.586,2.586,0,0,1,2.586,2.586V111.2A2.586,2.586,0,0,1,51.719,113.781Zm-7.758-5.172h5.172v-5.172H43.961Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 10.344,
    height: 10.344,
    transform: "translate(41.375 256.008)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M51.719,268.938H41.375a2.586,2.586,0,0,1-2.586-2.586V256.008a2.586,2.586,0,0,1,2.586-2.586H51.719a2.586,2.586,0,0,1,2.586,2.586v10.344A2.586,2.586,0,0,1,51.719,268.938Zm-7.758-5.172h5.172v-5.172H43.961Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 10.344,
    height: 10.344,
    transform: "translate(41.375 230.148)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M51.719,243.078H41.375a2.586,2.586,0,0,1-2.586-2.586V230.148a2.586,2.586,0,0,1,2.586-2.586H51.719a2.586,2.586,0,0,1,2.586,2.586v10.344A2.586,2.586,0,0,1,51.719,243.078Zm-7.758-5.172h5.172v-5.172H43.961Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M181.016,281.867a2.586,2.586,0,0,1-2.586-2.586V87.922a2.586,2.586,0,0,1,5.172,0V279.281A2.586,2.586,0,0,1,181.016,281.867Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M181.016,196.531H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M181.016,186.188H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M181.016,206.875H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M181.016,165.5H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M181.016,155.156H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M181.016,175.844H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M181.016,134.469H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M181.016,124.125H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M181.016,144.813H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M181.016,103.438H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M181.016,93.094H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M181.016,113.781H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M181.016,217.219H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M181.016,227.563H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M181.016,237.906H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M181.016,248.25H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M181.016,258.594H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M181.016,268.938H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M181.016,279.281H165.5a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 113.781,
    height: 10.318,
    transform: "translate(51.719 64.648)",
    fill: "#8d96b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M165.5,77.578H51.719a2.586,2.586,0,0,1-2.586-2.586V64.648a2.586,2.586,0,0,1,2.586-2.586H165.5a2.586,2.586,0,0,1,2.586,2.586V74.992A2.586,2.586,0,0,1,165.5,77.578ZM54.3,72.406H162.914V67.234H54.3Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 113.781,
    height: 222.391,
    transform: "translate(51.719 74.992)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M165.5,299.969H51.719a2.586,2.586,0,0,1-2.586-2.586V74.992a2.586,2.586,0,0,1,2.586-2.586H165.5a2.586,2.586,0,0,1,2.586,2.586V297.383A2.586,2.586,0,0,1,165.5,299.969ZM54.3,294.8H162.914V77.578H54.3Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 20.688,
    height: 25.859,
    transform: "translate(129.297 271.523)",
    fill: "#939fc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M149.984,299.969H129.3a2.586,2.586,0,0,1-2.586-2.586V271.523a2.586,2.586,0,0,1,2.586-2.586h20.688a2.586,2.586,0,0,1,2.586,2.586v25.859A2.586,2.586,0,0,1,149.984,299.969Zm-18.1-5.172H147.4V274.109H131.883Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 51.719,
    height: 15.516,
    transform: "translate(67.234 271.523)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M118.953,289.625H67.234a2.586,2.586,0,0,1-2.586-2.586V271.523a2.586,2.586,0,0,1,2.586-2.586h51.719a2.586,2.586,0,0,1,2.586,2.586v15.516A2.586,2.586,0,0,1,118.953,289.625ZM69.82,284.453h46.547V274.109H69.82Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 25.859,
    height: 15.516,
    transform: "translate(67.234 245.664)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M93.094,263.766H67.234a2.586,2.586,0,0,1-2.586-2.586V245.664a2.586,2.586,0,0,1,2.586-2.586H93.094a2.586,2.586,0,0,1,2.586,2.586V261.18A2.586,2.586,0,0,1,93.094,263.766ZM69.82,258.594H90.508V248.25H69.82Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M80.164,263.766a2.586,2.586,0,0,1-2.586-2.586V245.664a2.586,2.586,0,0,1,5.172,0V261.18A2.586,2.586,0,0,1,80.164,263.766Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 25.859,
    height: 15.516,
    transform: "translate(67.234 219.805)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M93.094,237.906H67.234a2.586,2.586,0,0,1-2.586-2.586V219.8a2.586,2.586,0,0,1,2.586-2.586H93.094A2.586,2.586,0,0,1,95.68,219.8V235.32A2.586,2.586,0,0,1,93.094,237.906ZM69.82,232.734H90.508V222.391H69.82Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M80.164,237.906a2.586,2.586,0,0,1-2.586-2.586V219.8a2.586,2.586,0,0,1,5.172,0V235.32A2.586,2.586,0,0,1,80.164,237.906Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 25.859,
    height: 15.516,
    transform: "translate(67.234 193.945)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M93.094,212.047H67.234a2.586,2.586,0,0,1-2.586-2.586V193.945a2.586,2.586,0,0,1,2.586-2.586H93.094a2.586,2.586,0,0,1,2.586,2.586v15.516A2.586,2.586,0,0,1,93.094,212.047ZM69.82,206.875H90.508V196.531H69.82Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M80.164,212.047a2.586,2.586,0,0,1-2.586-2.586V193.945a2.586,2.586,0,0,1,5.172,0v15.516A2.586,2.586,0,0,1,80.164,212.047Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 25.859,
    height: 15.516,
    transform: "translate(67.234 168.086)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M93.094,186.188H67.234a2.586,2.586,0,0,1-2.586-2.586V168.086a2.586,2.586,0,0,1,2.586-2.586H93.094a2.586,2.586,0,0,1,2.586,2.586V183.6A2.586,2.586,0,0,1,93.094,186.188ZM69.82,181.016H90.508V170.672H69.82Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M80.164,186.188a2.586,2.586,0,0,1-2.586-2.586V168.086a2.586,2.586,0,0,1,5.172,0V183.6A2.586,2.586,0,0,1,80.164,186.188Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 25.859,
    height: 15.516,
    transform: "translate(124.125 245.664)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M149.984,263.766H124.125a2.586,2.586,0,0,1-2.586-2.586V245.664a2.586,2.586,0,0,1,2.586-2.586h25.859a2.586,2.586,0,0,1,2.586,2.586V261.18A2.586,2.586,0,0,1,149.984,263.766Zm-23.273-5.172H147.4V248.25H126.711Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M137.055,263.766a2.586,2.586,0,0,1-2.586-2.586V245.664a2.586,2.586,0,0,1,5.172,0V261.18A2.586,2.586,0,0,1,137.055,263.766Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 25.859,
    height: 15.516,
    transform: "translate(124.125 219.805)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M149.984,237.906H124.125a2.586,2.586,0,0,1-2.586-2.586V219.8a2.586,2.586,0,0,1,2.586-2.586h25.859a2.586,2.586,0,0,1,2.586,2.586V235.32A2.586,2.586,0,0,1,149.984,237.906Zm-23.273-5.172H147.4V222.391H126.711Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M137.055,237.906a2.586,2.586,0,0,1-2.586-2.586V219.8a2.586,2.586,0,0,1,5.172,0V235.32A2.586,2.586,0,0,1,137.055,237.906Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 25.859,
    height: 15.516,
    transform: "translate(124.125 193.945)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M149.984,212.047H124.125a2.586,2.586,0,0,1-2.586-2.586V193.945a2.586,2.586,0,0,1,2.586-2.586h25.859a2.586,2.586,0,0,1,2.586,2.586v15.516A2.586,2.586,0,0,1,149.984,212.047Zm-23.273-5.172H147.4V196.531H126.711Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M137.055,212.047a2.586,2.586,0,0,1-2.586-2.586V193.945a2.586,2.586,0,0,1,5.172,0v15.516A2.586,2.586,0,0,1,137.055,212.047Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 25.859,
    height: 15.516,
    transform: "translate(124.125 168.086)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M149.984,186.188H124.125a2.586,2.586,0,0,1-2.586-2.586V168.086a2.586,2.586,0,0,1,2.586-2.586h25.859a2.586,2.586,0,0,1,2.586,2.586V183.6A2.586,2.586,0,0,1,149.984,186.188Zm-23.273-5.172H147.4V170.672H126.711Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M137.055,186.188a2.586,2.586,0,0,1-2.586-2.586V168.086a2.586,2.586,0,0,1,5.172,0V183.6A2.586,2.586,0,0,1,137.055,186.188Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    "data-name": "Rectangle 456",
    width: 25.859,
    height: 15.516,
    transform: "translate(67.234 142.227)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M93.094,160.328H67.234a2.586,2.586,0,0,1-2.586-2.586V142.227a2.586,2.586,0,0,1,2.586-2.586H93.094a2.586,2.586,0,0,1,2.586,2.586v15.516A2.586,2.586,0,0,1,93.094,160.328ZM69.82,155.156H90.508V144.813H69.82Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M80.164,160.328a2.586,2.586,0,0,1-2.586-2.586V142.227a2.586,2.586,0,0,1,5.172,0v15.516A2.586,2.586,0,0,1,80.164,160.328Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_457",
    "data-name": "Rectangle 457",
    width: 25.859,
    height: 15.516,
    transform: "translate(124.125 142.227)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M149.984,160.328H124.125a2.586,2.586,0,0,1-2.586-2.586V142.227a2.586,2.586,0,0,1,2.586-2.586h25.859a2.586,2.586,0,0,1,2.586,2.586v15.516A2.586,2.586,0,0,1,149.984,160.328Zm-23.273-5.172H147.4V144.813H126.711Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M137.055,160.328a2.586,2.586,0,0,1-2.586-2.586V142.227a2.586,2.586,0,0,1,5.172,0v15.516A2.586,2.586,0,0,1,137.055,160.328Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    "data-name": "Rectangle 458",
    width: 25.859,
    height: 15.516,
    transform: "translate(67.234 116.367)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M93.094,134.469H67.234a2.586,2.586,0,0,1-2.586-2.586V116.367a2.586,2.586,0,0,1,2.586-2.586H93.094a2.586,2.586,0,0,1,2.586,2.586v15.516A2.586,2.586,0,0,1,93.094,134.469ZM69.82,129.3H90.508V118.953H69.82Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M80.164,134.469a2.586,2.586,0,0,1-2.586-2.586V116.367a2.586,2.586,0,0,1,5.172,0v15.516A2.586,2.586,0,0,1,80.164,134.469Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 25.859,
    height: 15.516,
    transform: "translate(124.125 116.367)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M149.984,134.469H124.125a2.586,2.586,0,0,1-2.586-2.586V116.367a2.586,2.586,0,0,1,2.586-2.586h25.859a2.586,2.586,0,0,1,2.586,2.586v15.516A2.586,2.586,0,0,1,149.984,134.469ZM126.711,129.3H147.4V118.953H126.711Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M137.055,134.469a2.586,2.586,0,0,1-2.586-2.586V116.367a2.586,2.586,0,0,1,5.172,0v15.516A2.586,2.586,0,0,1,137.055,134.469Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    width: 25.859,
    height: 15.516,
    transform: "translate(67.234 90.508)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M93.094,108.609H67.234a2.586,2.586,0,0,1-2.586-2.586V90.508a2.586,2.586,0,0,1,2.586-2.586H93.094a2.586,2.586,0,0,1,2.586,2.586v15.516A2.586,2.586,0,0,1,93.094,108.609ZM69.82,103.438H90.508V93.094H69.82Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M80.164,108.609a2.586,2.586,0,0,1-2.586-2.586V90.508a2.586,2.586,0,0,1,5.172,0v15.516A2.586,2.586,0,0,1,80.164,108.609Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    "data-name": "Rectangle 461",
    width: 25.859,
    height: 15.516,
    transform: "translate(124.125 90.508)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M149.984,108.609H124.125a2.586,2.586,0,0,1-2.586-2.586V90.508a2.586,2.586,0,0,1,2.586-2.586h25.859a2.586,2.586,0,0,1,2.586,2.586v15.516A2.586,2.586,0,0,1,149.984,108.609Zm-23.273-5.172H147.4V93.094H126.711Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M137.055,108.609a2.586,2.586,0,0,1-2.586-2.586V90.508a2.586,2.586,0,0,1,5.172,0v15.516A2.586,2.586,0,0,1,137.055,108.609Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    width: 10.344,
    height: 170.672,
    transform: "translate(103.438 90.508)",
    fill: "#97c1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M113.781,263.766H103.438a2.586,2.586,0,0,1-2.586-2.586V90.508a2.586,2.586,0,0,1,2.586-2.586h10.344a2.586,2.586,0,0,1,2.586,2.586V261.18A2.586,2.586,0,0,1,113.781,263.766Zm-7.758-5.172H111.2V93.094h-5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M113.781,243.078H103.438a2.586,2.586,0,0,1,0-5.172h10.344a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M113.781,217.219H103.438a2.586,2.586,0,0,1,0-5.172h10.344a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M113.781,191.359H103.438a2.586,2.586,0,0,1,0-5.172h10.344a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M113.781,165.5H103.438a2.586,2.586,0,0,1,0-5.172h10.344a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M113.781,139.641H103.438a2.586,2.586,0,0,1,0-5.172h10.344a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M113.781,113.781H103.438a2.586,2.586,0,0,1,0-5.172h10.344a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M165.5,77.578H51.719a2.586,2.586,0,0,1,0-5.172H165.5a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M170.672,67.234H46.547a2.586,2.586,0,0,1,0-5.172H170.672a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    "data-name": "Rectangle 463",
    width: 129.297,
    height: 36.203,
    transform: "translate(12.93 152.648)",
    fill: "#97c1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M142.227,191.359H12.93a2.586,2.586,0,0,1-2.586-2.586v-36.2a2.586,2.586,0,0,1,2.586-2.586h129.3a2.586,2.586,0,0,1,2.586,2.586v36.2A2.586,2.586,0,0,1,142.227,191.359ZM15.516,186.188H139.641V155.156H15.516Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M131.883,199.195v-5.172l-54.3-34.988-54.3,34.988v5.172H18.1V297.46H137.055V199.195Z",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M137.055,299.969H18.1a2.586,2.586,0,0,1-2.586-2.586V199.117a2.586,2.586,0,0,1,2.586-2.586h2.586v-2.586a2.586,2.586,0,0,1,1.19-2.172l54.3-34.988a2.586,2.586,0,0,1,2.793,0l54.3,34.988a2.586,2.586,0,0,1,1.19,2.172v2.586h2.586a2.586,2.586,0,0,1,2.586,2.586v98.266A2.586,2.586,0,0,1,137.055,299.969ZM20.688,294.8H134.469V201.7h-2.586a2.586,2.586,0,0,1-2.586-2.586v-3.672L77.578,162.112,25.859,195.445v3.672a2.586,2.586,0,0,1-2.586,2.586H20.688Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    width: 46.547,
    height: 31.031,
    transform: "translate(33.617 256.085)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M80.164,289.625H33.617a2.586,2.586,0,0,1-2.586-2.586V256.008a2.586,2.586,0,0,1,2.586-2.586H80.164a2.586,2.586,0,0,1,2.586,2.586v31.031A2.586,2.586,0,0,1,80.164,289.625ZM36.2,284.453H77.578V258.594H36.2Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 15.516,
    height: 20.688,
    transform: "translate(33.617 209.539)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M49.133,232.734H33.617a2.586,2.586,0,0,1-2.586-2.586V209.461a2.586,2.586,0,0,1,2.586-2.586H49.133a2.586,2.586,0,0,1,2.586,2.586v20.688A2.586,2.586,0,0,1,49.133,232.734ZM36.2,227.563H46.547V212.047H36.2Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M126.711,178.507V155.234H111.2v13.757Z",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M126.711,181.016a2.586,2.586,0,0,1-1.345-.388l-15.516-9.516a2.586,2.586,0,0,1-1.241-2.2V155.156a2.586,2.586,0,0,1,2.586-2.586h15.516a2.586,2.586,0,0,1,2.586,2.586V178.43A2.586,2.586,0,0,1,126.711,181.016Zm-12.93-13.55,10.344,6.336V157.742H113.781Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466",
    "data-name": "Rectangle 466",
    width: 20.688,
    height: 7.758,
    transform: "translate(108.609 147.476)",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M129.3,157.742H108.609a2.586,2.586,0,0,1-2.586-2.586V147.4a2.586,2.586,0,0,1,2.586-2.586H129.3a2.586,2.586,0,0,1,2.586,2.586v7.758A2.586,2.586,0,0,1,129.3,157.742Zm-18.1-5.172h15.516v-2.586H111.2Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M56.891,289.625a2.586,2.586,0,0,1-2.586-2.586V256.008a2.586,2.586,0,0,1,5.172,0v31.031A2.586,2.586,0,0,1,56.891,289.625Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M82.75,289.625H31.031a2.586,2.586,0,0,1,0-5.172H82.75a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_467",
    "data-name": "Rectangle 467",
    width: 25.859,
    height: 33.617,
    transform: "translate(95.68 256.085)",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M121.539,292.211H95.68a2.586,2.586,0,0,1-2.586-2.586V256.008a2.586,2.586,0,0,1,2.586-2.586h25.859a2.586,2.586,0,0,1,2.586,2.586v33.617A2.586,2.586,0,0,1,121.539,292.211Zm-23.273-5.172h20.688V258.594H98.266Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M100.852,276.7H95.68a2.586,2.586,0,0,1,0-5.172h5.172a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_468",
    "data-name": "Rectangle 468",
    width: 31.031,
    height: 7.758,
    transform: "translate(93.094 289.703)",
    fill: "#939fc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M124.125,299.969H93.094a2.586,2.586,0,0,1-2.586-2.586v-7.758a2.586,2.586,0,0,1,2.586-2.586h31.031a2.586,2.586,0,0,1,2.586,2.586v7.758A2.586,2.586,0,0,1,124.125,299.969ZM95.68,294.8h25.859v-2.586H95.68Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 15.516,
    height: 20.688,
    transform: "translate(106.023 209.539)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M121.539,232.734H106.023a2.586,2.586,0,0,1-2.586-2.586V209.461a2.586,2.586,0,0,1,2.586-2.586h15.516a2.586,2.586,0,0,1,2.586,2.586v20.688A2.586,2.586,0,0,1,121.539,232.734Zm-12.93-5.172h10.344V212.047H108.609Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M51.719,232.734H31.031a2.586,2.586,0,0,1,0-5.172H51.719a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_470",
    "data-name": "Rectangle 470",
    width: 15.516,
    height: 20.688,
    transform: "translate(69.82 209.539)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M85.336,232.734H69.82a2.586,2.586,0,0,1-2.586-2.586V209.461a2.586,2.586,0,0,1,2.586-2.586H85.336a2.586,2.586,0,0,1,2.586,2.586v20.688A2.586,2.586,0,0,1,85.336,232.734Zm-12.93-5.172H82.75V212.047H72.406Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M49.133,222.391H33.617a2.586,2.586,0,0,1,0-5.172H49.133a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M85.336,222.391H69.82a2.586,2.586,0,0,1,0-5.172H85.336a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M121.539,222.391H106.023a2.586,2.586,0,0,1,0-5.172h15.516a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M124.125,232.734H103.438a2.586,2.586,0,0,1,0-5.172h20.688a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M87.922,232.734H67.234a2.586,2.586,0,0,1,0-5.172H87.922a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M69.82,188.773v-7.758a7.758,7.758,0,0,1,7.758-7.758h0a7.758,7.758,0,0,1,7.758,7.758v7.758Z",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M85.336,191.359H69.82a2.586,2.586,0,0,1-2.586-2.586v-7.758a10.344,10.344,0,0,1,20.688,0v7.758A2.586,2.586,0,0,1,85.336,191.359Zm-12.93-5.172H82.75v-5.172a5.172,5.172,0,0,0-10.344,0Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M87.922,191.359H67.234a2.586,2.586,0,0,1,0-5.172H87.922a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M137.055,248.25H20.688a2.586,2.586,0,0,1,0-5.172H137.055a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M137.055,201.7H20.688a2.586,2.586,0,0,1,0-5.172H137.055a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M131.883,199.195v-5.172l-54.3-34.988-54.3,34.988v5.172H12.93V188.851l64.648-41.375,64.648,41.375v10.344Z",
    fill: "#97c1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M142.227,201.7H131.883a2.586,2.586,0,0,1-2.586-2.586v-3.672L77.578,162.112,25.859,195.445v3.672a2.586,2.586,0,0,1-2.586,2.586H12.93a2.586,2.586,0,0,1-2.586-2.586V188.773a2.586,2.586,0,0,1,1.19-2.172l64.648-41.375a2.586,2.586,0,0,1,2.793,0L143.623,186.6a2.586,2.586,0,0,1,1.19,2.172v10.344A2.586,2.586,0,0,1,142.227,201.7Zm-7.758-5.172h5.172v-6.258l-62.062-39.72-62.062,39.72v6.258h5.172v-2.586a2.586,2.586,0,0,1,1.19-2.172l54.3-34.988a2.586,2.586,0,0,1,2.793,0l54.3,34.988a2.586,2.586,0,0,1,1.19,2.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M56.891,287.039a7.758,7.758,0,0,0-2.9.569,7.758,7.758,0,0,0-11.818-4.4,12.93,12.93,0,0,0-23.067,1.345,10.151,10.151,0,0,0-1.034,0A10.344,10.344,0,0,0,7.732,294.9v2.586H64.648V294.9a7.758,7.758,0,0,0-7.758-7.861Z",
    fill: "#b1f1a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M64.648,299.969H7.758a2.586,2.586,0,0,1-2.586-2.586V294.8a12.93,12.93,0,0,1,12.413-12.93,15.516,15.516,0,0,1,25.446-1.991,10.344,10.344,0,0,1,12.49,4.655,10.109,10.109,0,0,1,1.371,0,10.344,10.344,0,0,1,10.344,10.344v2.586A2.586,2.586,0,0,1,64.648,299.969Zm-54.3-5.172H62.063a5.172,5.172,0,0,0-7.085-4.784,2.586,2.586,0,0,1-3.465-1.733,5.172,5.172,0,0,0-7.758-2.948,2.586,2.586,0,0,1-3.7-.853,10.388,10.388,0,0,0-18.541,1.086,2.586,2.586,0,0,1-2.586,1.552h-.44l-.388-.078a7.758,7.758,0,0,0-7.758,7.758Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M33.9,289.935a2.586,2.586,0,0,1-1.526-.517c-1.293-.957-2.043-.828-2.87-.284a2.586,2.586,0,0,1-2.741-4.37,7.215,7.215,0,0,1,8.715.517,2.586,2.586,0,0,1-1.552,4.655Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    width: 67.234,
    height: 10.344,
    transform: "translate(206.875 28.523)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M274.109,41.375H206.875a2.586,2.586,0,0,1-2.586-2.586V28.445a2.586,2.586,0,0,1,2.586-2.586h67.234a2.586,2.586,0,0,1,2.586,2.586V38.789A2.586,2.586,0,0,1,274.109,41.375ZM209.461,36.2h62.063V31.031H209.461Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    width: 10.344,
    height: 72.406,
    transform: "translate(165.5 225.054)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M175.844,299.969H165.5a2.586,2.586,0,0,1-2.586-2.586V224.977a2.586,2.586,0,0,1,2.586-2.586h10.344a2.586,2.586,0,0,1,2.586,2.586v72.406A2.586,2.586,0,0,1,175.844,299.969Zm-7.758-5.172h5.172V227.563h-5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_473",
    "data-name": "Rectangle 473",
    width: 15.516,
    height: 72.406,
    transform: "translate(175.844 225.054)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M191.359,299.969H175.844a2.586,2.586,0,0,1-2.586-2.586V224.977a2.586,2.586,0,0,1,2.586-2.586h15.516a2.586,2.586,0,0,1,2.586,2.586v72.406A2.586,2.586,0,0,1,191.359,299.969ZM178.43,294.8h10.344V227.563H178.43Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_474",
    "data-name": "Rectangle 474",
    width: 10.344,
    height: 72.406,
    transform: "translate(305.141 225.054)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M315.484,299.969H305.141a2.586,2.586,0,0,1-2.586-2.586V224.977a2.586,2.586,0,0,1,2.586-2.586h10.344a2.586,2.586,0,0,1,2.586,2.586v72.406A2.586,2.586,0,0,1,315.484,299.969Zm-7.758-5.172H312.9V227.563h-5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_475",
    "data-name": "Rectangle 475",
    width: 15.516,
    height: 72.406,
    transform: "translate(289.625 225.054)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M305.141,299.969H289.625a2.586,2.586,0,0,1-2.586-2.586V224.977a2.586,2.586,0,0,1,2.586-2.586h15.516a2.586,2.586,0,0,1,2.586,2.586v72.406A2.586,2.586,0,0,1,305.141,299.969Zm-12.93-5.172h10.344V227.563H292.211Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 98.266,
    height: 258.594,
    transform: "translate(191.359 38.867)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M289.625,299.969H191.359a2.586,2.586,0,0,1-2.586-2.586V38.789a2.586,2.586,0,0,1,2.586-2.586h98.266a2.586,2.586,0,0,1,2.586,2.586V297.383A2.586,2.586,0,0,1,289.625,299.969Zm-95.68-5.172h93.094V41.375H193.945Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 77.578,
    height: 206.875,
    transform: "translate(201.703 49.21)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M279.281,258.594H201.7a2.586,2.586,0,0,1-2.586-2.586V49.133a2.586,2.586,0,0,1,2.586-2.586h77.578a2.586,2.586,0,0,1,2.586,2.586V256.008A2.586,2.586,0,0,1,279.281,258.594Zm-74.992-5.172H276.7V51.719H204.289Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 77.578,
    height: 41.375,
    transform: "translate(201.703 256.085)",
    fill: "#d4edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M279.281,299.969H201.7a2.586,2.586,0,0,1-2.586-2.586V256.008a2.586,2.586,0,0,1,2.586-2.586h77.578a2.586,2.586,0,0,1,2.586,2.586v41.375A2.586,2.586,0,0,1,279.281,299.969ZM204.289,294.8H276.7v-36.2H204.289Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M263.766,258.594a2.586,2.586,0,0,1-2.586-2.586V49.133a2.586,2.586,0,0,1,5.172,0V256.008A2.586,2.586,0,0,1,263.766,258.594Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M248.25,258.594a2.586,2.586,0,0,1-2.586-2.586V49.133a2.586,2.586,0,0,1,5.172,0V256.008A2.586,2.586,0,0,1,248.25,258.594Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M232.734,258.594a2.586,2.586,0,0,1-2.586-2.586V49.133a2.586,2.586,0,0,1,5.172,0V256.008A2.586,2.586,0,0,1,232.734,258.594Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M240.492,31.031a2.586,2.586,0,0,1-2.586-2.586V18.1a2.586,2.586,0,0,1,5.172,0V28.445A2.586,2.586,0,0,1,240.492,31.031Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 25.859,
    height: 10.344,
    transform: "translate(165.5 287.117)",
    fill: "#939fc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M191.359,299.969H165.5a2.586,2.586,0,0,1-2.586-2.586V287.039a2.586,2.586,0,0,1,2.586-2.586h25.859a2.586,2.586,0,0,1,2.586,2.586v10.344A2.586,2.586,0,0,1,191.359,299.969ZM168.086,294.8h20.688v-5.172H168.086Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M217.219,258.594a2.586,2.586,0,0,1-2.586-2.586V49.133a2.586,2.586,0,0,1,5.172,0V256.008A2.586,2.586,0,0,1,217.219,258.594Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M222.391,299.969a2.586,2.586,0,0,1-2.586-2.586V256.008a2.586,2.586,0,0,1,5.172,0v41.375A2.586,2.586,0,0,1,222.391,299.969Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M258.594,299.969a2.586,2.586,0,0,1-2.586-2.586V256.008a2.586,2.586,0,0,1,5.172,0v41.375A2.586,2.586,0,0,1,258.594,299.969Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M240.492,299.969a2.586,2.586,0,0,1-2.586-2.586V256.008a2.586,2.586,0,0,1,5.172,0v41.375A2.586,2.586,0,0,1,240.492,299.969Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M279.281,206.875H201.7a2.586,2.586,0,0,1,0-5.172h77.578a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M279.281,232.734H201.7a2.586,2.586,0,0,1,0-5.172h77.578a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M279.281,129.3H201.7a2.586,2.586,0,0,1,0-5.172h77.578a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M279.281,155.156H201.7a2.586,2.586,0,0,1,0-5.172h77.578a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M279.281,181.016H201.7a2.586,2.586,0,0,1,0-5.172h77.578a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M279.281,77.578H201.7a2.586,2.586,0,0,1,0-5.172h77.578a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M279.281,103.438H201.7a2.586,2.586,0,0,1,0-5.172h77.578a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M279.281,258.594H201.7a2.586,2.586,0,0,1,0-5.172h77.578a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M305.141,289.625a2.586,2.586,0,0,1-2.586-2.586V235.32a2.586,2.586,0,0,1,5.172,0v51.719A2.586,2.586,0,0,1,305.141,289.625Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_480",
    "data-name": "Rectangle 480",
    width: 25.859,
    height: 10.344,
    transform: "translate(289.625 287.117)",
    fill: "#939fc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M315.484,299.969H289.625a2.586,2.586,0,0,1-2.586-2.586V287.039a2.586,2.586,0,0,1,2.586-2.586h25.859a2.586,2.586,0,0,1,2.586,2.586v10.344A2.586,2.586,0,0,1,315.484,299.969ZM292.211,294.8H312.9v-5.172H292.211Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 25.859,
    height: 10.344,
    transform: "translate(289.625 225.054)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M315.484,237.906H289.625a2.586,2.586,0,0,1-2.586-2.586V224.977a2.586,2.586,0,0,1,2.586-2.586h25.859a2.586,2.586,0,0,1,2.586,2.586V235.32A2.586,2.586,0,0,1,315.484,237.906Zm-23.273-5.172H312.9v-5.172H292.211Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 25.859,
    height: 10.344,
    transform: "translate(165.5 225.054)",
    fill: "#c9c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M191.359,237.906H165.5a2.586,2.586,0,0,1-2.586-2.586V224.977a2.586,2.586,0,0,1,2.586-2.586h25.859a2.586,2.586,0,0,1,2.586,2.586V235.32A2.586,2.586,0,0,1,191.359,237.906Zm-23.273-5.172h20.688v-5.172H168.086Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M292.444,299.762a2.586,2.586,0,0,1-2.586-2.586V276.488a2.586,2.586,0,0,1,5.172,0v20.688A2.586,2.586,0,0,1,292.444,299.762Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M307.959,262.266a15.516,15.516,0,0,1-31.031,0c0-7.758,6.956-42.668,15.516-42.668S307.959,254.4,307.959,262.266Z",
    fill: "#b1f1a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M292.444,279.074a17.507,17.507,0,0,1-18.1-16.809c0-5.043,6.051-45.254,18.1-45.254s18.1,40.211,18.1,45.254A17.507,17.507,0,0,1,292.444,279.074Zm0-56.891c-5.172,0-12.93,30.488-12.93,40.082a12.93,12.93,0,0,0,25.859,0C305.373,252.672,297.667,222.184,292.444,222.184Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M289.134,268.369a2.586,2.586,0,0,1-.646,0,7.241,7.241,0,0,1-5.637-6.646,2.606,2.606,0,0,1,5.172-.646c.207,1.577.8,2.043,1.784,2.276a2.6,2.6,0,0,1-.621,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M295.081,244.035a2.586,2.586,0,0,1-2.146-1.138c-.905-1.319-1.629-1.448-2.586-1.241a2.648,2.648,0,1,1-1.138-5.172,7.241,7.241,0,0,1,8.042,3.362,2.586,2.586,0,0,1-2.146,4.034Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M165.862,287.479a7.758,7.758,0,0,1,11.74-4.189,12.93,12.93,0,0,1,23.558,2.974,10.344,10.344,0,0,1,16.059,8.534v2.586H160.328V294.8a7.758,7.758,0,0,1,5.534-7.318Z",
    fill: "#b1f1a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M217.219,299.969H160.328a2.586,2.586,0,0,1-2.586-2.586V294.8a10.344,10.344,0,0,1,6.1-9.413,10.344,10.344,0,0,1,12.93-5.508,15.516,15.516,0,0,1,25.859,2.715A12.93,12.93,0,0,1,219.8,294.8v2.586A2.586,2.586,0,0,1,217.219,299.969Zm-54.3-5.172h51.719a7.758,7.758,0,0,0-12.025-6.465,2.586,2.586,0,0,1-3.931-1.474,10.27,10.27,0,0,0-18.826-2.4,2.586,2.586,0,0,1-3.7.853A5.172,5.172,0,0,0,168.4,288.1a2.586,2.586,0,0,1-1.733,1.733,5.172,5.172,0,0,0-3.75,4.965Zm2.948-7.4Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M191.644,289.78a2.586,2.586,0,0,1-1.422-.44c-1.319-.879-2.069-.724-2.9-.129A2.586,2.586,0,1,1,184.351,285a7.215,7.215,0,0,1,8.715,0,2.586,2.586,0,0,1-1.422,4.732Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M289.625,299.969H59.477a2.586,2.586,0,0,1,0-5.172H289.625a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M328.414,299.969H297.383a2.586,2.586,0,0,1,0-5.172h31.031a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M15.516,299.969H2.586a2.586,2.586,0,0,1,0-5.172h12.93a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M51.719,299.969H23.273a2.586,2.586,0,0,1,0-5.172H51.719a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M305.141,325.828H10.344a2.586,2.586,0,0,1,0-5.172h294.8a2.586,2.586,0,0,1,0,5.172Z",
    fill: "#6d6daa"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 196.531,
    height: 15.516,
    transform: "translate(67.234 307.727)",
    fill: "#d6b5b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M263.766,325.828H67.234a2.586,2.586,0,0,1-2.586-2.586V307.727a2.586,2.586,0,0,1,2.586-2.586H263.766a2.586,2.586,0,0,1,2.586,2.586v15.516A2.586,2.586,0,0,1,263.766,325.828ZM69.82,320.656H261.18V310.313H69.82Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 217.219,
    height: 175.844,
    transform: "translate(56.891 147.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M263.766,157.742v165.5H67.234v-165.5H263.766Z",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M274.109,177.706l-8.12-13.55a2.586,2.586,0,0,0-2.224-1.241H67.234a2.586,2.586,0,0,0-2.224,1.267l-8.12,13.525v30.669a12.8,12.8,0,0,0,15.516-4.086,12.93,12.93,0,0,0,20.687,0,12.93,12.93,0,0,0,20.688,0,12.93,12.93,0,0,0,20.688,0,12.93,12.93,0,0,0,20.688,0,12.93,12.93,0,0,0,20.688,0,12.93,12.93,0,0,0,20.687,0,12.93,12.93,0,0,0,20.688,0,12.93,12.93,0,0,0,20.687,0,12.93,12.93,0,0,0,20.688,0,12.8,12.8,0,0,0,15.516,4.163Z",
    fill: "#7690a8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M263.766,325.828H67.234a2.586,2.586,0,0,1-2.586-2.586v-165.5a2.586,2.586,0,0,1,2.586-2.586H263.766a2.586,2.586,0,0,1,2.586,2.586v165.5A2.586,2.586,0,0,1,263.766,325.828ZM69.82,320.656H261.18V160.328H69.82Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M274.109,325.828H56.891a2.586,2.586,0,0,1-2.586-2.586V147.4a2.586,2.586,0,0,1,2.586-2.586H274.109A2.586,2.586,0,0,1,276.7,147.4V323.242A2.586,2.586,0,0,1,274.109,325.828ZM59.477,320.656H271.523V149.984H59.477Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 222.391,
    height: 10.344,
    transform: "translate(54.305 137.055)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M276.7,149.984H54.3a2.586,2.586,0,0,1-2.586-2.586V137.055a2.586,2.586,0,0,1,2.586-2.586H276.7a2.586,2.586,0,0,1,2.586,2.586V147.4A2.586,2.586,0,0,1,276.7,149.984Zm-219.8-5.172H274.109v-5.172H56.891Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 87.922,
    height: 46.547,
    transform: "translate(121.539 100.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M209.461,149.984H121.539a2.586,2.586,0,0,1-2.586-2.586V100.852a2.586,2.586,0,0,1,2.586-2.586h87.922a2.586,2.586,0,0,1,2.586,2.586V147.4A2.586,2.586,0,0,1,209.461,149.984Zm-85.336-5.172h82.75V103.438h-82.75Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M62.063,199.117h0a10.344,10.344,0,0,1-10.344-10.344V183.6H72.406v5.172A10.344,10.344,0,0,1,62.063,199.117Z",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M62.063,201.7a12.93,12.93,0,0,1-12.93-12.93V183.6a2.586,2.586,0,0,1,2.586-2.586H72.406a2.586,2.586,0,0,1,2.586,2.586v5.172A12.93,12.93,0,0,1,62.063,201.7ZM54.3,186.188v2.586a7.758,7.758,0,0,0,15.516,0v-2.586Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M82.75,199.117h0a10.344,10.344,0,0,1-10.344-10.344V183.6H93.094v5.172A10.344,10.344,0,0,1,82.75,199.117Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M82.75,201.7a12.93,12.93,0,0,1-12.93-12.93V183.6a2.586,2.586,0,0,1,2.586-2.586H93.094A2.586,2.586,0,0,1,95.68,183.6v5.172A12.93,12.93,0,0,1,82.75,201.7Zm-7.758-15.516v2.586a7.758,7.758,0,0,0,15.516,0v-2.586Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M103.438,199.117h0a10.344,10.344,0,0,1-10.344-10.344V183.6h20.688v5.172A10.344,10.344,0,0,1,103.438,199.117Z",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M103.438,201.7a12.93,12.93,0,0,1-12.93-12.93V183.6a2.586,2.586,0,0,1,2.586-2.586h20.688a2.586,2.586,0,0,1,2.586,2.586v5.172A12.93,12.93,0,0,1,103.438,201.7ZM95.68,186.188v2.586a7.758,7.758,0,0,0,15.516,0v-2.586Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M124.125,199.117h0a10.344,10.344,0,0,1-10.344-10.344V183.6h20.688v5.172A10.344,10.344,0,0,1,124.125,199.117Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M124.125,201.7a12.93,12.93,0,0,1-12.93-12.93V183.6a2.586,2.586,0,0,1,2.586-2.586h20.688a2.586,2.586,0,0,1,2.586,2.586v5.172A12.93,12.93,0,0,1,124.125,201.7Zm-7.758-15.516v2.586a7.758,7.758,0,0,0,15.516,0v-2.586Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M144.813,199.117h0a10.344,10.344,0,0,1-10.344-10.344V183.6h20.688v5.172A10.344,10.344,0,0,1,144.813,199.117Z",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M144.813,201.7a12.93,12.93,0,0,1-12.93-12.93V183.6a2.586,2.586,0,0,1,2.586-2.586h20.688a2.586,2.586,0,0,1,2.586,2.586v5.172A12.93,12.93,0,0,1,144.813,201.7Zm-7.758-15.516v2.586a7.758,7.758,0,0,0,15.516,0v-2.586Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M186.188,199.117h0a10.344,10.344,0,0,1-10.344-10.344V183.6h20.688v5.172A10.344,10.344,0,0,1,186.188,199.117Z",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M186.188,201.7a12.93,12.93,0,0,1-12.93-12.93V183.6a2.586,2.586,0,0,1,2.586-2.586h20.688a2.586,2.586,0,0,1,2.586,2.586v5.172A12.93,12.93,0,0,1,186.188,201.7Zm-7.758-15.516v2.586a7.758,7.758,0,0,0,15.516,0v-2.586Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M206.875,199.117h0a10.344,10.344,0,0,1-10.344-10.344V183.6h20.688v5.172A10.344,10.344,0,0,1,206.875,199.117Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M206.875,201.7a12.93,12.93,0,0,1-12.93-12.93V183.6a2.586,2.586,0,0,1,2.586-2.586h20.688A2.586,2.586,0,0,1,219.8,183.6v5.172A12.93,12.93,0,0,1,206.875,201.7Zm-7.758-15.516v2.586a7.758,7.758,0,0,0,15.516,0v-2.586Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M227.563,199.117h0a10.344,10.344,0,0,1-10.344-10.344V183.6h20.688v5.172A10.344,10.344,0,0,1,227.563,199.117Z",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M227.563,201.7a12.93,12.93,0,0,1-12.93-12.93V183.6a2.586,2.586,0,0,1,2.586-2.586h20.688a2.586,2.586,0,0,1,2.586,2.586v5.172A12.93,12.93,0,0,1,227.563,201.7ZM219.8,186.188v2.586a7.758,7.758,0,0,0,15.516,0v-2.586Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M248.25,199.117h0a10.344,10.344,0,0,1-10.344-10.344V183.6h20.688v5.172A10.344,10.344,0,0,1,248.25,199.117Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M248.25,201.7a12.93,12.93,0,0,1-12.93-12.93V183.6a2.586,2.586,0,0,1,2.586-2.586h20.688a2.586,2.586,0,0,1,2.586,2.586v5.172A12.93,12.93,0,0,1,248.25,201.7Zm-7.758-15.516v2.586a7.758,7.758,0,0,0,15.516,0v-2.586Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M268.938,199.117h0a10.344,10.344,0,0,1-10.344-10.344V183.6h20.688v5.172A10.344,10.344,0,0,1,268.938,199.117Z",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M268.938,201.7a12.93,12.93,0,0,1-12.93-12.93V183.6a2.586,2.586,0,0,1,2.586-2.586h20.688a2.586,2.586,0,0,1,2.586,2.586v5.172a12.93,12.93,0,0,1-12.93,12.93Zm-7.758-15.516v2.586a7.758,7.758,0,0,0,15.516,0v-2.586Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M72.406,183.6H51.719l15.516-25.859H82.75Z",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M72.406,186.188H51.719a2.586,2.586,0,0,1-2.224-3.9L65.01,156.423a2.586,2.586,0,0,1,2.224-1.267H82.75a2.586,2.586,0,0,1,2.4,3.543L74.811,184.558A2.586,2.586,0,0,1,72.406,186.188ZM56.3,181.016H70.674l8.275-20.687H68.6Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M93.094,183.6H72.406L82.75,157.742h18.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M93.094,186.188H72.406a2.586,2.586,0,0,1-2.4-3.543l10.344-25.859a2.586,2.586,0,0,1,2.4-1.629h18.1a2.586,2.586,0,0,1,2.586,3.336L95.68,184.351A2.586,2.586,0,0,1,93.094,186.188Zm-16.86-5.172H91.18l6.206-20.687H84.457Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M113.781,183.6H93.094l7.758-25.859h18.1Z",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M113.781,186.188H93.094a2.586,2.586,0,0,1-2.586-3.336l7.758-25.859a2.586,2.586,0,0,1,2.586-1.836h18.1a2.586,2.586,0,0,1,2.586,3.1l-5.172,25.859A2.586,2.586,0,0,1,113.781,186.188Zm-17.222-5.172h15.1l4.137-20.687h-12.93Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M134.469,183.6H113.781l5.172-25.859h18.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M134.469,186.188H113.781a2.586,2.586,0,0,1-2.586-3.1l5.172-25.859a2.586,2.586,0,0,1,2.586-2.069h18.1A2.586,2.586,0,0,1,139.641,158l-2.586,25.859A2.586,2.586,0,0,1,134.469,186.188Zm-17.533-5.172h15.205l2.069-20.687H121.074Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M155.156,183.6H134.469l2.586-25.859h18.1Z",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M155.156,186.188H134.469a2.586,2.586,0,0,1-2.586-2.845l2.586-25.859a2.586,2.586,0,0,1,2.586-2.327h18.1a2.586,2.586,0,0,1,2.586,2.586V183.6A2.586,2.586,0,0,1,155.156,186.188Zm-17.817-5.172H152.57V160.328H139.408Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M165.5,199.117h0a10.344,10.344,0,0,1-10.344-10.344V183.6h20.688v5.172A10.344,10.344,0,0,1,165.5,199.117Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M165.5,201.7a12.93,12.93,0,0,1-12.93-12.93V183.6a2.586,2.586,0,0,1,2.586-2.586h20.688a2.586,2.586,0,0,1,2.586,2.586v5.172A12.93,12.93,0,0,1,165.5,201.7Zm-7.758-15.516v2.586a7.758,7.758,0,0,0,15.516,0v-2.586Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 20.688,
    height: 25.859,
    transform: "translate(155.156 157.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M175.844,186.188H155.156a2.586,2.586,0,0,1-2.586-2.586V157.742a2.586,2.586,0,0,1,2.586-2.586h20.688a2.586,2.586,0,0,1,2.586,2.586V183.6A2.586,2.586,0,0,1,175.844,186.188Zm-18.1-5.172h15.516V160.328H157.742Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M196.531,183.6H175.844V157.742h18.1Z",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M196.531,186.188H175.844a2.586,2.586,0,0,1-2.586-2.586V157.742a2.586,2.586,0,0,1,2.586-2.586h18.1a2.586,2.586,0,0,1,2.586,2.327l2.586,25.859a2.586,2.586,0,0,1-2.586,2.845Zm-18.1-5.172h15.231l-2.069-20.687H178.43Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M217.219,183.6H196.531l-2.586-25.859h18.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M217.219,186.188H196.531a2.586,2.586,0,0,1-2.586-2.327L191.359,158a2.586,2.586,0,0,1,2.586-2.845h18.1a2.586,2.586,0,0,1,2.586,2.069l5.172,25.859a2.586,2.586,0,0,1-2.586,3.1Zm-18.334-5.172H214.09l-4.137-20.687H196.816Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M237.906,183.6H217.219l-5.172-25.859h18.1Z",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M237.906,186.188H217.219a2.586,2.586,0,0,1-2.586-2.069l-5.172-25.859a2.586,2.586,0,0,1,2.586-3.1h18.1a2.586,2.586,0,0,1,2.586,1.836l7.758,25.859a2.586,2.586,0,0,1-2.586,3.336Zm-18.567-5.172h15.1l-6.206-20.687h-12.93Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M258.594,183.6H237.906l-7.758-25.859h18.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M258.594,186.188H237.906a2.586,2.586,0,0,1-2.586-1.836l-7.758-25.859a2.586,2.586,0,0,1,2.586-3.336h18.1a2.586,2.586,0,0,1,2.4,1.629L261,182.645a2.586,2.586,0,0,1-2.4,3.543Zm-18.774-5.172h14.947l-8.275-20.687h-12.93Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M279.281,183.6H258.594L248.25,157.742h15.516Z",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M279.281,186.188H258.594a2.586,2.586,0,0,1-2.4-1.629L245.845,158.7a2.586,2.586,0,0,1,2.4-3.543h15.516a2.586,2.586,0,0,1,2.224,1.267l15.516,25.86a2.586,2.586,0,0,1-2.224,3.9Zm-18.929-5.172H274.73l-12.413-20.687H251.974Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_488",
    "data-name": "Rectangle 488",
    width: 90.508,
    height: 77.578,
    transform: "translate(82.75 219.805)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M82.75,279.514l90.508-42.978V219.8H82.75Z",
    fill: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M82.75,288.875,173.258,245.9v-5.172L82.75,283.7Z",
    fill: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_489",
    "data-name": "Rectangle 489",
    width: 90.508,
    height: 7.758,
    transform: "translate(82.75 219.805)",
    fill: "#1c64ba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M173.258,299.969H82.75a2.586,2.586,0,0,1-2.586-2.586V219.8a2.586,2.586,0,0,1,2.586-2.586h90.508a2.586,2.586,0,0,1,2.586,2.586v77.578A2.586,2.586,0,0,1,173.258,299.969ZM85.336,294.8h85.336V222.391H85.336Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_490",
    "data-name": "Rectangle 490",
    width: 95.68,
    height: 7.758,
    transform: "translate(80.164 297.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M175.844,307.727H80.164a2.586,2.586,0,0,1-2.586-2.586v-7.758a2.586,2.586,0,0,1,2.586-2.586h95.68a2.586,2.586,0,0,1,2.586,2.586v7.758A2.586,2.586,0,0,1,175.844,307.727ZM82.75,302.555h90.508v-2.586H82.75Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_491",
    "data-name": "Rectangle 491",
    width: 59.477,
    height: 87.922,
    transform: "translate(188.773 219.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M248.25,310.313H188.773a2.586,2.586,0,0,1-2.586-2.586V219.8a2.586,2.586,0,0,1,2.586-2.586H248.25a2.586,2.586,0,0,1,2.586,2.586v87.922A2.586,2.586,0,0,1,248.25,310.313Zm-56.891-5.172h54.3v-82.75h-54.3Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_492",
    "data-name": "Rectangle 492",
    width: 43.961,
    height: 31.031,
    transform: "translate(196.531 227.563)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M196.531,227.563V245.2l37.134-17.636Z",
    fill: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 43.961,
    height: 7.758,
    transform: "translate(196.531 227.563)",
    fill: "#1c64ba"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 43.961,
    height: 31.031,
    transform: "translate(196.531 268.938)",
    fill: "#96d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M196.531,288.177l40.5-19.239H226.14l-29.609,14.068Z",
    fill: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495",
    "data-name": "Rectangle 495",
    width: 43.961,
    height: 7.758,
    transform: "translate(196.531 268.938)",
    fill: "#1c64ba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M240.492,261.18H196.531a2.586,2.586,0,0,1-2.586-2.586V227.563a2.586,2.586,0,0,1,2.586-2.586h43.961a2.586,2.586,0,0,1,2.586,2.586v31.031A2.586,2.586,0,0,1,240.492,261.18Zm-41.375-5.172h38.789V230.148H199.117Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M240.492,302.555H196.531a2.586,2.586,0,0,1-2.586-2.586V268.938a2.586,2.586,0,0,1,2.586-2.586h43.961a2.586,2.586,0,0,1,2.586,2.586v31.031A2.586,2.586,0,0,1,240.492,302.555Zm-41.375-5.172h38.789V271.523H199.117Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496",
    "data-name": "Rectangle 496",
    width: 59.477,
    height: 7.758,
    transform: "translate(188.773 307.727)",
    fill: "#9eb2cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M248.25,318.07H188.773a2.586,2.586,0,0,1-2.586-2.586v-7.758a2.586,2.586,0,0,1,2.586-2.586H248.25a2.586,2.586,0,0,1,2.586,2.586v7.758A2.586,2.586,0,0,1,248.25,318.07ZM191.359,312.9h54.3v-2.586h-54.3Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    width: 59.477,
    height: 7.758,
    transform: "translate(188.773 315.484)",
    fill: "#9eb2cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M248.25,325.828H188.773a2.586,2.586,0,0,1-2.586-2.586v-7.758a2.586,2.586,0,0,1,2.586-2.586H248.25a2.586,2.586,0,0,1,2.586,2.586v7.758A2.586,2.586,0,0,1,248.25,325.828Zm-56.891-5.172h54.3V318.07h-54.3Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M89.215,307.727a11.585,11.585,0,0,0-4.319.853,11.585,11.585,0,0,0-17.662-6.594A19.317,19.317,0,0,0,32.66,304a15.206,15.206,0,0,0-1.552-.155,15.516,15.516,0,0,0-15.516,15.516v3.879h85.258v-3.879a11.637,11.637,0,0,0-11.637-11.637Z",
    fill: "#b1f1a8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M89.215,307.727a11.585,11.585,0,0,0-4.319.853,11.585,11.585,0,0,0-17.662-6.594A19.317,19.317,0,0,0,32.66,304a15.163,15.163,0,0,0-1.552-.155,15.516,15.516,0,0,0-15.516,15.516v3.879h.517a15.516,15.516,0,0,1,15-11.637,15.163,15.163,0,0,1,1.552.155,19.317,19.317,0,0,1,34.574-2.017,11.585,11.585,0,0,1,17.714,6.594,11.533,11.533,0,0,1,15.257,6.9h.646v-3.879a11.637,11.637,0,0,0-11.637-11.637Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M100.852,325.828H15.516a2.586,2.586,0,0,1-2.586-2.586v-3.879a18.1,18.1,0,0,1,18.1-18.1h0a21.877,21.877,0,0,1,36.979-2.586,14.171,14.171,0,0,1,18.438,6.853,13.91,13.91,0,0,1,2.767-.388,14.249,14.249,0,0,1,14.223,14.223v3.879A2.586,2.586,0,0,1,100.852,325.828ZM18.1,320.656H98.266v-1.293a9.025,9.025,0,0,0-12.413-8.378,2.586,2.586,0,0,1-3.465-1.733A9,9,0,0,0,68.6,304.08a2.586,2.586,0,0,1-3.7-.853,16.6,16.6,0,0,0-14.481-8.43A16.783,16.783,0,0,0,34.91,305.141a2.586,2.586,0,0,1-2.586,1.552H31.031a12.93,12.93,0,0,0-12.93,12.93Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M54.744,310.649a2.586,2.586,0,0,1-1.526-.517,4.474,4.474,0,0,0-5.767-.491,2.641,2.641,0,1,1-2.767-4.5,9.645,9.645,0,0,1,11.585.724,2.586,2.586,0,0,1-1.552,4.655Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M248.25,312.9a7.758,7.758,0,0,1,2.9.569,7.758,7.758,0,0,1,11.818-4.4,12.93,12.93,0,0,1,23.067,1.345,10.143,10.143,0,0,1,1.034,0,10.344,10.344,0,0,1,10.344,10.344v2.586H240.492V320.76a7.758,7.758,0,0,1,7.758-7.861Z",
    fill: "#b1f1a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M297.383,325.828H240.492a2.586,2.586,0,0,1-2.586-2.586v-2.586a10.344,10.344,0,0,1,10.344-10.344,10.079,10.079,0,0,1,1.371,0,10.344,10.344,0,0,1,12.49-4.655,15.516,15.516,0,0,1,25.446,1.991,12.93,12.93,0,0,1,12.413,12.93v2.586a2.586,2.586,0,0,1-2.586,2.664Zm-54.3-5.172H294.8a7.758,7.758,0,0,0-7.758-7.758h-.776a2.586,2.586,0,0,1-2.586-1.552,10.385,10.385,0,0,0-18.489-1.034,2.586,2.586,0,0,1-3.7.853,5.172,5.172,0,0,0-7.758,2.948,2.586,2.586,0,0,1-3.465,1.733,5.172,5.172,0,0,0-7.189,4.81Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M271.213,315.795a2.586,2.586,0,0,1-1.552-4.655,7.241,7.241,0,0,1,8.715-.517,2.586,2.586,0,1,1-2.741,4.37c-.853-.543-1.6-.646-2.87.284A2.586,2.586,0,0,1,271.213,315.795Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M149.984,118.953a2.586,2.586,0,0,1-1.552-4.655l10.344-7.758a2.586,2.586,0,0,1,3.1,4.137l-10.344,7.758a2.586,2.586,0,0,1-1.552.517Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M181.016,118.953a2.586,2.586,0,0,1-1.552-.517l-10.344-7.758a2.586,2.586,0,1,1,3.1-4.137l10.344,7.758a2.586,2.586,0,0,1-1.552,4.655Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M181.016,139.641H149.984L147.4,124.125h36.2Z",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M181.016,142.227H149.984a2.586,2.586,0,0,1-2.586-2.172l-2.586-15.516a2.586,2.586,0,0,1,2.586-3h36.2a2.586,2.586,0,0,1,2.586,3L183.6,140.054A2.586,2.586,0,0,1,181.016,142.227Zm-28.833-5.172h26.635l1.733-10.344h-30.1Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 41.375,
    height: 7.758,
    transform: "translate(144.813 116.367)",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M186.188,126.711H144.813a2.586,2.586,0,0,1-2.586-2.586v-7.758a2.586,2.586,0,0,1,2.586-2.586h41.375a2.586,2.586,0,0,1,2.586,2.586v7.758A2.586,2.586,0,0,1,186.188,126.711ZM147.4,121.539h36.2v-2.586H147.4Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M201.7,142.227a2.715,2.715,0,0,1-1.836-.75,4.343,4.343,0,0,1-.31-.388,1.914,1.914,0,0,1-.233-.465,1.681,1.681,0,0,1-.207-.465,1.784,1.784,0,0,1,0-.517,2.586,2.586,0,0,1,5.172,0,3.262,3.262,0,0,1,0,.517,1.6,1.6,0,0,1-.155.465,2.018,2.018,0,0,1-.233.465l-.31.388a2.715,2.715,0,0,1-1.888.75Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M129.3,111.2a2.715,2.715,0,0,1-1.836-.75,2.431,2.431,0,0,1-.543-.853,1.681,1.681,0,0,1-.207-.465,3.57,3.57,0,0,1,0-.517,2.613,2.613,0,0,1,3.077-2.534,1.578,1.578,0,0,1,.491.155,1.966,1.966,0,0,1,.465.233l.388.31a2.586,2.586,0,0,1,0,3.672l-.388.31a1.966,1.966,0,0,1-.465.233,1.6,1.6,0,0,1-.491.155Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M129.3,142.227a2.715,2.715,0,0,1-1.836-.75,2.821,2.821,0,0,1-.75-1.836,3.57,3.57,0,0,1,0-.517,1.681,1.681,0,0,1,.155-.465,2.586,2.586,0,0,1,.543-.853,2.974,2.974,0,0,1,.853-.543,2.4,2.4,0,0,1,1.474-.155,1.578,1.578,0,0,1,.491.155,1.965,1.965,0,0,1,.465.233l.388.31a2.586,2.586,0,0,1,0,3.672l-.388.31a1.965,1.965,0,0,1-.465.233,1.6,1.6,0,0,1-.491.155Z",
    fill: "#6d6daa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M201.7,111.2a2.715,2.715,0,0,1-1.836-.75,2.975,2.975,0,0,1-.543-.853,2.147,2.147,0,0,1-.207-.983,2.586,2.586,0,1,1,4.965.983,2.974,2.974,0,0,1-.543.853,2.715,2.715,0,0,1-1.836.75Z",
    fill: "#6d6daa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStore);
export default __webpack_public_path__ + "static/media/no-store.23aa884fc83e2dd839514d5da194b9c0.svg";
export { ForwardRef as ReactComponent };